import { normalizarTexto, somenteDigitos } from '../lib/textoBR'
import type { Cliente } from '../db/tipos'

function distanciaLevenshtein(a: string, b: string): number {
  const linhaAnterior = Array.from({ length: b.length + 1 }, (_, i) => i)
  for (let i = 0; i < a.length; i++) {
    let anterior = i + 1
    for (let j = 0; j < b.length; j++) {
      const custo = a[i] === b[j] ? 0 : 1
      const atual = Math.min(linhaAnterior[j + 1] + 1, anterior + 1, linhaAnterior[j] + custo)
      linhaAnterior[j] = anterior
      anterior = atual
    }
    linhaAnterior[b.length] = anterior
  }
  return linhaAnterior[b.length]
}

export function similaridade(a: string, b: string): number {
  const na = normalizarTexto(a)
  const nb = normalizarTexto(b)
  if (na === nb) return 1
  const maior = Math.max(na.length, nb.length)
  if (maior === 0) return 0
  return 1 - distanciaLevenshtein(na, nb) / maior
}

const LIMIAR_NOME = 0.85

export function encontrarDuplicata(
  candidato: { razao_social: string; cnpj_cpf?: string },
  existentes: Cliente[],
): { forca: 'forte' | 'provavel'; cliente: Cliente } | null {
  const docCandidato = candidato.cnpj_cpf ? somenteDigitos(candidato.cnpj_cpf) : ''

  // 1) documento igual = forte
  if (docCandidato) {
    const porDoc = existentes.find(
      (c) => c.cnpj_cpf && somenteDigitos(c.cnpj_cpf) === docCandidato,
    )
    if (porDoc) return { forca: 'forte', cliente: porDoc }
  }
  // 2) nome parecido = provavel (pega o mais parecido acima do limiar).
  // Telefone NAO entra: numeros compartilhados/placeholder entre empresas
  // diferentes geravam falsos "possiveis duplicados" na importacao.
  let melhor: { pontuacao: number; cliente: Cliente } | null = null
  for (const existente of existentes) {
    const pontuacao = Math.max(
      similaridade(candidato.razao_social, existente.razao_social),
      existente.nome_fantasia ? similaridade(candidato.razao_social, existente.nome_fantasia) : 0,
    )
    if (pontuacao >= LIMIAR_NOME && (!melhor || pontuacao > melhor.pontuacao)) {
      melhor = { pontuacao, cliente: existente }
    }
  }
  return melhor ? { forca: 'provavel', cliente: melhor.cliente } : null
}
